import { Request } from 'hooks/requestHooks'
import { RequestEntities, ServiceEntities } from 'interfaces/RequestEntities'
import Service from 'interfaces/Services'
import { connect } from 'react-redux'

interface OwnProps {
    requestId: number | string
}

interface StateProps {
    request?: Request
    service?: Service
    requestEntities?: RequestEntities
    serviceEntities?: ServiceEntities
}

interface RootState {
    requests: {
        entities: {
            requests?: Record<number | string, Request>
        }
    }
    services: {
        entities: {
            services?: Record<number, Service>
        }
    }
}

function mapStateToProps(state: RootState, props: OwnProps): StateProps {
    const { requests, ...requestEntities } = state.requests.entities
    const { services, ...serviceEntities } = state.services.entities
    const request = requests && requests[props.requestId]
    const service = request && services && services[request.service_id as number]
    return {
        requestEntities: requestEntities as RequestEntities,
        serviceEntities: serviceEntities as ServiceEntities,
        request,
        service,
    }
}

export default connect(mapStateToProps, null)
